<template>
    <FormModal :model="model" :init="init" modal-id="shipping_hscode">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-group
                    label-cols-sm="2"
                    label="保存名"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.name"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.name" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="HSコード"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.hs_code"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.hs_code" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="原産国"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <SelectCountry
                        v-model="model.country"
                        />
                    <input-error :errors="error.type" />
                </b-form-group>
            </template>
            <template v-else>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'
import AddressContent from '@/components/AddressContent.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import SelectCurrencyId from '@/components/SelectCurrencyId.vue'

export default {
    components: {
        FormModal,
        AddressContent,
        SelectCountry,
        InputError,
        SelectCurrencyId,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>


